import { ibanValidation } from "@shared-kernel/primary/forms/validations/iban";
import { number, object } from "yup";
import { REQUIRED_FIELD } from "@shared-kernel/primary/forms/constants";
import { MAX_HOURLY_PRICE, TEACHER_MIN_HOURLY_PRICE } from "@academy-context/write/domain/constants/shared";

// ============================================================================
// Billing Step Schema (Step 1)
// ============================================================================

export const billingStepSchema = object({
  defaultPrice: number()
    .typeError(`Minimum ${TEACHER_MIN_HOURLY_PRICE}€`)
    .positive(`Minimum ${TEACHER_MIN_HOURLY_PRICE}€`)
    .min(TEACHER_MIN_HOURLY_PRICE, `Minimum ${TEACHER_MIN_HOURLY_PRICE}€`)
    .max(MAX_HOURLY_PRICE, `Maximum ${MAX_HOURLY_PRICE}€`)
    .required(REQUIRED_FIELD),
  iban: ibanValidation(),
});

export type BillingStepInputs = {
  defaultPrice: number | null;
  iban: string;
};
